// src/pages/performance/manageAppraisals.hooks.js
import { useEffect, useState } from "react";
import api from "../../services/api";


import { API, WORKFLOW_TEMPLATE_OPTIONS_FALLBACK } from "./manageAppraisals.constants";
import { normalizeToArray, buildWorkflowOptionsFromApi } from "./manageAppraisals.utils";

export function useWorkflowTemplateOptions() {
  const [options, setOptions] = useState(WORKFLOW_TEMPLATE_OPTIONS_FALLBACK);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const res = await api.get(API.workflowTemplates, { params: { per_page: 500 } });
        const list = normalizeToArray(res);
        const next = buildWorkflowOptionsFromApi(list);

        if (alive && Array.isArray(next) && next.length > 1) setOptions(next);
      } catch {
        // keep fallback
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  return options;
}
